import * as React from 'react';
import { IIconProps } from '@cian/ui-kit/icons/internal/types';

export const IconFunctionalWarningSign24 = ({ color }: IIconProps) => {
  const currentColor = color ? `var(--${color})` : 'currentColor';

  return (
    // eslint-disable-next-line react/forbid-elements
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8682 3.26949C12.4843 2.59767 11.5156 2.59767 11.1317 3.26949L0.854914 21.2539C0.473968 21.9206 0.955334 22.7501 1.72316 22.7501H22.2768C23.0446 22.7501 23.526 21.9206 23.145 21.2539L12.8682 3.26949ZM13 8.75006H11L11 15.7501H13L13 8.75006ZM13.25 18.5001C13.25 17.8097 12.6903 17.2501 12 17.2501C11.3096 17.2501 10.75 17.8097 10.75 18.5001C10.75 19.1904 11.3096 19.7501 12 19.7501C12.6903 19.7501 13.25 19.1904 13.25 18.5001Z"
        fill={currentColor}
      />
    </svg>
  );
};
